export const UMO_UTILS_EMAIL_REQUEST = 'UMO_UTILS_EMAIL_REQUEST';
export const UMO_UTILS_EMAIL_SUCCESS = 'UMO_UTILS_EMAIL_SUCCESS';
export const UMO_UTILS_EMAIL_FAILURE = 'UMO_UTILS_EMAIL_FAILURE';
export const UMO_UTILS_EMAIL_DISMISS = 'UMO_UTILS_EMAIL_DISMISS';
export const UMO_UTILS_DMZ_PUSH_REQUEST = 'UMO_UTILS_DMZ_PUSH_REQUEST';
export const UMO_UTILS_DMZ_PUSH_FAILURE = 'UMO_UTILS_DMZ_PUSH_FAILURE';
export const UMO_UTILS_DMZ_PUSH_SUCCESS = 'UMO_UTILS_DMZ_PUSH_SUCCESS';
export const UMO_UTILS_MANIPULATION_REQUEST = 'UMO_UTILS_MANIPULATION_REQUEST';
export const UMO_UTILS_MANIPULATION_SUCCESS = 'UMO_UTILS_MANIPULATION_SUCCESS';
export const UMO_UTILS_MANIPULATION_FAILURE = 'UMO_UTILS_MANIPULATION_FAILURE';

export const WORKSPACE_DOWNLOAD_OPTIONS_REQUEST = 'WORKSPACE_DOWNLOAD_OPTIONS_REQUEST';
export const WORKSPACE_DOWNLOAD_OPTIONS_SUCCESS = 'WORKSPACE_DOWNLOAD_OPTIONS_SUCCESS';
export const WORKSPACE_DOWNLOAD_OPTIONS_FAILURE = 'WORKSPACE_DOWNLOAD_OPTIONS_FAILURE';

export const UMO_DOWNLOAD_USAGE_REQUEST = 'UMO_DOWNLOAD_USAGE_REQUEST';
export const UMO_DOWNLOAD_USAGE_SUCCESS = 'UMO_DOWNLOAD_USAGE_SUCCESS';
export const UMO_DOWNLOAD_USAGE_FAILURE = 'UMO_DOWNLOAD_USAGE_FAILURE';
